import {
  PROGRAMADO_DIA_RECEIVED,
  PROGRAMADO_MES_RECEIVED,
  PROGRAMADO_SEMANA_RECEIVED,
  REAL_DIA_RECEIVED,
  REAL_MES_RECEIVED,
  REAL_SEMANA_RECEIVED,
  RESET_PROGRESO_OBRA,
} from "../actions/types";
import {
  EDIT_PROYECTO,
  VIEW_OPTIONS,
  HIDE_OPTIONS,
  PROYECTOS_RECEIVED,
  CREATE_NUEVA_PROYECTO,
  SET_PROPERTY_PROYECTO,
  SINGLE_PROYECTO_RECEIVED,
  ULTIMO_AVANCE_RECEIVED,
  AVANCES_DIA_RECEIVED,
  PROYECCION_RECEIVED,
  AVANCE_FINANCIERO_RECEIVED,
  HISTORIAL_RECEIVED,
} from "../types/proyectos";

const schema = {
  idProyecto: null,
  nombre: "",
  calle: "",
  idAdjunto: null,
};

export default (state, { type, payload }) => {
  switch (type) {
    case SINGLE_PROYECTO_RECEIVED:
      return { ...state, proyecto: payload };
    // undefined = loading, null = no avances, object = latest avance
    case ULTIMO_AVANCE_RECEIVED:
      return { ...state, ultimoAvance: payload };
    // undefined while loading, null when it couldn't be loaded.
    case AVANCES_DIA_RECEIVED:
      return { ...state, avancesDia: payload };
    case PROYECCION_RECEIVED:
      return { ...state, proyeccion: payload };
    case AVANCE_FINANCIERO_RECEIVED:
      return { ...state, avanceFinanciero: payload };
    // Change history pages: offset 0 replaces, the next pages are appended.
    case HISTORIAL_RECEIVED: {
      if (payload === null) return { ...state, historial: null };
      const { items, offset, hasMore } = payload;
      const historial =
        offset === 0 ? items : [...(state.historial || []), ...items];
      return { ...state, historial, historialHasMore: hasMore };
    }
    case PROYECTOS_RECEIVED:
      return { ...state, proyectos: payload, proyecto: null };
    case VIEW_OPTIONS:
      return { ...state, options: payload };
    case HIDE_OPTIONS:
      return { ...state, options: null };
    case CREATE_NUEVA_PROYECTO:
      return {
        ...state,
        proyecto: schema,
      };
    case EDIT_PROYECTO:
      return { ...state, proyecto: payload };
    case SET_PROPERTY_PROYECTO: {
      const { key, value } = payload;
      const proyecto = { ...state.proyecto };
      proyecto[key] = value;
      return { ...state, proyecto };
    }
    case RESET_PROGRESO_OBRA:
      return { ...state, progresoObra: null };
    case PROGRAMADO_DIA_RECEIVED:
      return {
        ...state,
        progresoObra: {
          ...state.progresoObra,
          programadoDia: payload,
        },
      };
    case REAL_DIA_RECEIVED:
      return {
        ...state,
        progresoObra: {
          ...state.progresoObra,
          realDia: payload,
        },
      };
    case PROGRAMADO_SEMANA_RECEIVED:
      return {
        ...state,
        progresoObra: {
          ...state.progresoObra,
          programadoSemana: payload,
        },
      };
    case REAL_SEMANA_RECEIVED:
      return {
        ...state,
        progresoObra: {
          ...state.progresoObra,
          realSemana: payload,
        },
      };
    case PROGRAMADO_MES_RECEIVED:
      return {
        ...state,
        progresoObra: {
          ...state.progresoObra,
          programadoMes: payload,
        },
      };
    case REAL_MES_RECEIVED:
      return {
        ...state,
        progresoObra: {
          ...state.progresoObra,
          realMes: payload,
        },
      };
    default:
      return { ...state };
  }
};
